// extracted by mini-css-extract-plugin
export default {"link-post":"LinkPost_link-post__gBtvb","link-post__input":"LinkPost_link-post__input__2N9JC","link-post__loader":"LinkPost_link-post__loader__OQCqI"};